export default [
  {
    title: 'Name',
    type: 'text',
    required: true,
    dataIndex: 'name',
    initialValue: '',
  }, {
    title: 'Code',
    type: 'text',
    // required: true,
    dataIndex: 'code',
    initialValue: '',
  }, {
    title: 'Province',
    required: true,
    type: 'SelectQuery',
    data: 'provinces',
    initialValue: undefined,
    selectedKey: 'pk',
    selectedValue: 'name',
    dataIndex: 'province',
    additional: 'edit|add',
  },
];